import Crud from "./Crud";
import CrudForm from './CrudForm'
import states from './states';

Crud.Form = CrudForm;
Crud.states = states;

export default Crud;
export { states };